import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GIButton, Modal } from 'app-components';
import { useDispatch, useSelector } from 'react-redux';

import { useApiHandler } from '../hooks/useApiHandler';
import { ROOT_STATE } from '../../../../store/store.types';
import { StyledModal } from '../constants/ticketlist.styled';
import { formatDate } from '../../../../utils/dates/date.utils';
import { DATE_FORMATS } from '../../../../utils/dates/dateMethods';
import { IExportTicketsModal } from '../constants/ticketlist.interface';

export const ExportTicketsModal = ({ onClose }: IExportTicketsModal) => {
    const dispatch = useDispatch();
    const { exportTicketListAPI } = useApiHandler();
    const { ticketAssignee, ticketRequestors } = useSelector((state: ROOT_STATE) => state.ticketMgmt.ticketsList);
    const onSubmit = async () => {
        const ticketListSearchVarsV1 = sessionStorage.getItem('ticketListSearchVarsV1');
        const parsedSearchCriteria = ticketListSearchVarsV1 ? JSON.parse(ticketListSearchVarsV1) : {};
        const payload = {
            isSimplifiedView: parsedSearchCriteria.isSimplifiedView || false,
            ticketSubject: parsedSearchCriteria.ticketSubject || '',
            ticketComments: parsedSearchCriteria.ticketComments || '',
            ticketNumber: parsedSearchCriteria.ticketNumber || '',
            submittedAfter: parsedSearchCriteria.submittedAfter
                ? formatDate(parsedSearchCriteria.submittedAfter, DATE_FORMATS.MM_DD_YYYY) || ''
                : '',
            submittedBefore: parsedSearchCriteria.submittedBefore
                ? formatDate(parsedSearchCriteria.submittedBefore, DATE_FORMATS.MM_DD_YYYY) || ''
                : '',
            assignee: ticketAssignee[parsedSearchCriteria.assignee] || '',
            assigneeId: parsedSearchCriteria.assignee || '',
            tagId: '',
            requestedByName: ticketRequestors[parsedSearchCriteria.requestedByName] || '',
            requestedBy: parsedSearchCriteria.requestedBy || '',
            requestedBytagId: parsedSearchCriteria.requestedBytagId || '',
            'userRole.id': '',
            roleId: '',
            'role.id': '',
            customFieldSelect: parsedSearchCriteria.customFieldSelect || -1,
            ticketCategorySelect: parsedSearchCriteria.ticketCategorySelect || -1,
            taskStatus: '',
            archiveFlagValue: false,
            isReportPageCall: parsedSearchCriteria.isReportPageCall || '',
            csrftoken: window.csrf_token,
        };

        await exportTicketListAPI(dispatch, payload);
        onClose();
    };

    return (
        <StyledModal>
            <Modal id="exportTicketModal" data-testid="export-ticket-modal">
                <Modal.Header
                    id="exportTicketModalHeader"
                    titleId="ticketList.modal.exportTicket.header"
                    data-testid="export-ticket-modal-header"
                    onHide={onClose}
                />
                <Modal.Body data-testid="export-ticket-modal-body">
                    <FormattedMessage
                        id="ticketList.modal.exportTicket.body"
                        values={{
                            br: <br />,
                        }}
                    />
                </Modal.Body>
                <Modal.Controls data-testid="export-ticket-modal-controls">
                    <GIButton
                        id="exportTicketModalNoButton"
                        onClickHandler={onClose}
                        variant="secondary"
                        labelId="common.cancel"
                    />
                    <GIButton
                        id="exportTicketModalYesButton"
                        onClickHandler={onSubmit}
                        variant="primary"
                        labelId="button.export"
                    />
                </Modal.Controls>
            </Modal>
        </StyledModal>
    );
};
